import Big from "big.js";

export const ceilBig = (b: Big) => {
  if (b.eq(b.round(0, 0))) {
    return b;
  }
  if (b.lt(0)) {
    return b.round(0, 0);
  }
  return b.add(1).round(0, 0);
};

export const floorBig = (b: Big) => {
  if (b.eq(b.round(0, 0))) {
    return b;
  }
  if (b.lt(0)) {
    return b.sub(1).round(0, 0);
  }
  return b.round(0, 0);
};
